<template>
  <div class="md:h-screen flex flex-col-reverse md:flex-row">
    <div class="w-full md:w-1/2 p-2 grid grid-cols-1 xl:grid-cols-2">
      <div
        class="experience shadow-lg h-74 w-5/6 flex justify-center items-center cursor-pointer"
        v-for="(experience, index) in experiences"
        :key="index"
      >
        <experience-tile :prop-data="experience" />
      </div>
    </div>

    <div
      class="bg-gray-800 h-20 md:h-screen flex flex-col justify-center w-full md:w-1/2"
    >
      <h3 class="font-bold text-4xl left-header text-yellow-400">Experience</h3>
      <navigation :primary="'light'" class="md:mt-64" />
    </div>
  </div>
</template>
<script>
import Navigation from "./Navigation";
import ExperienceTile from "./widget/ExperienceTile";
export default {
  components: {
    Navigation,
    ExperienceTile,
  },
  data() {
    return {
      experiences: [
        {
          name: "Xncreations",
          img: "xn.png",
          img_size: "lg",
          tile_subtitle: "Role :Web Developer",
          desc: "Duration: 1.5 years",
          desc2: "",
        },
        {
          name: "Get My Grades",
          img: "gmg.png",
          img_size: "sm",
          tile_subtitle: "Role :Junior Developer",
          desc: "Duration: 6 months",
          desc2:
            "The Ultimate Learning Platform. Perfect for use alongside school or homeschooling programmes for students",
        },
        {
          name: "Persistent Systems",
          img: "psl.png",
          img_size: "lg",
          tile_subtitle: "Role :Junior Developer",
          desc: "Duration: 6 months",
          desc2: "",
        },
        {
          name: "Smart India Hackathon",
          img: "sih.png",
          img_size: "sm",
          tile_subtitle: "Role :Developer",
        },
      ],
    };
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Piedra&display=swap");
.left-header {
  font-family: "Piedra", cursive;
  letter-spacing: 5px;
  word-spacing: 10px;
}

.experience {
  align-self: center;
  justify-self: center;
  padding: 1em;
}
</style>
